import enCommon from './en/common.json';
import enHeader from './en/header.json';
import enSettings from './en/settings.json';
import enManagerSelfService from './en/managerSelfService.json';
import enEmployeeDirectory from './en/employeeDirectory.json';
import enInternalMessaging from './en/internalMessaging.json';
import enTimeOffManagement from './en/timeOffManagement.json';
import enIncidentReports from './en/incidentReports.json';
import enHiring from './en/hiring.json';
import enTrainings from './en/trainings.json';
import enSupport from './en/support.json';
import enEmployeeScheduling from './en/employeeScheduling.json';
import enServiceUnavailable from './en/serviceUnavailable.json';
import deCommon from './de/common.json';
import deHeader from './de/header.json';
import deSettings from './de/settings.json';
import deManagerSelfService from './de/managerSelfService.json';
import deEmployeeDirectory from './de/employeeDirectory.json';
import deInternalMessaging from './de/internalMessaging.json';
import deTimeOffManagement from './de/timeOffManagement.json';
import deIncidentReports from './de/incidentReports.json';
import deHiring from './de/hiring.json';
import deTrainings from './de/trainings.json';
import deSupport from './de/support.json';
import deEmployeeScheduling from './de/employeeScheduling.json';
import deServiceUnavailable from './de/serviceUnavailable.json';
import frCommon from './fr/common.json';
import frHeader from './fr/header.json';
import frSettings from './fr/settings.json';
import frManagerSelfService from './fr/managerSelfService.json';
import frEmployeeDirectory from './fr/employeeDirectory.json';
import frInternalMessaging from './fr/internalMessaging.json';
import frTimeOffManagement from './fr/timeOffManagement.json';
import frIncidentReports from './fr/incidentReports.json';
import frHiring from './fr/hiring.json';
import frTrainings from './fr/trainings.json';
import frSupport from './fr/support.json';
import frEmployeeScheduling from './fr/employeeScheduling.json';
import frServiceUnavailable from './fr/serviceUnavailable.json';
import {
  DEFAULT_LANGUAGE as DEFAULT_LANGUAGE_CONSTANT,
  SUPPORTED_LANGUAGES as SUPPORTED_LANGUAGES_CONSTANT,
} from 'shared';

export const DEFAULT_LANGUAGE = DEFAULT_LANGUAGE_CONSTANT;
export const SUPPORTED_LANGUAGES = [...SUPPORTED_LANGUAGES_CONSTANT];

const resources = {
  en: {
    common: enCommon,
    header: enHeader,
    settings: enSettings,
    managerSelfService: enManagerSelfService,
    employeeDirectory: enEmployeeDirectory,
    internalMessaging: enInternalMessaging,
    timeOffManagement: enTimeOffManagement,
    incidentReports: enIncidentReports,
    hiring: enHiring,
    trainings: enTrainings,
    support: enSupport,
    employeeScheduling: enEmployeeScheduling,
    serviceUnavailable: enServiceUnavailable,
  },
  de: {
    common: deCommon,
    header: deHeader,
    settings: deSettings,
    managerSelfService: deManagerSelfService,
    employeeDirectory: deEmployeeDirectory,
    internalMessaging: deInternalMessaging,
    timeOffManagement: deTimeOffManagement,
    incidentReports: deIncidentReports,
    hiring: deHiring,
    trainings: deTrainings,
    support: deSupport,
    employeeScheduling: deEmployeeScheduling,
    serviceUnavailable: deServiceUnavailable,
  },
  fr: {
    common: frCommon,
    header: frHeader,
    settings: frSettings,
    managerSelfService: frManagerSelfService,
    employeeDirectory: frEmployeeDirectory,
    internalMessaging: frInternalMessaging,
    timeOffManagement: frTimeOffManagement,
    incidentReports: frIncidentReports,
    hiring: frHiring,
    trainings: frTrainings,
    support: frSupport,
    employeeScheduling: frEmployeeScheduling,
    serviceUnavailable: frServiceUnavailable,
  },
};

export default resources;
